import Seo from "@/components/Seo";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ServiceCards } from "@/components/ServiceCards";
import { About } from "@/components/About";
import { MarriageHall } from "@/components/MarriageHall";
import { Rooms } from "@/components/Rooms";
import { Restaurant } from "@/components/Restaurant";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Gallery } from "@/components/Gallery";
import { CtaBand } from "@/components/CtaBand";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { MobileBar } from "@/components/MobileBar";

function App() {
  return (
    <div className="min-h-screen bg-ivory font-sans text-ink">
      <Seo
        title="Kasdol Hotel | Marriage Hall, Hotel Rooms & Restaurant"
        siteName="Kasdol Hotel"
        description="Kasdol Hotel offers a complete hospitality experience with a marriage hall, comfortable hotel rooms and restaurant services under one roof."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Hotel",
          name: "Kasdol Hotel",
          telephone: "+918349247470",
          description:
            "Kasdol Hotel offers a complete hospitality experience with a marriage hall, comfortable hotel rooms and restaurant services under one roof.",
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <ServiceCards />
        <About />
        <MarriageHall />
        <Rooms />
        <Restaurant />
        <WhyChooseUs />
        <Gallery />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}

export default App;
